import { required, maxLength, numeric } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    inicio: { required, maxLength: maxLength(10), numeric },
    quantidade: { required, numeric, maxLength: maxLength(2) },
  },
}

export const validateComputed = {
  inicioErrors() {
    const errors = []
    if (!this.$v.form.inicio.$dirty) return errors
    !this.$v.form.inicio.maxLength && errors.push('Número não pode ter mais de 10 dígitos')
    !this.$v.form.inicio.required && errors.push('Número é obrigatório.')
    !this.$v.form.inicio.numeric && errors.push('Apenas caracteres numéricos são válidos.')
    return errors
  },
  quantidadeErrors() {
    const errors = []
    if (!this.$v.form.quantidade.$dirty) return errors
    !this.$v.form.quantidade.maxLength && errors.push('Número não pode ter mais de 2 dígitos')
    !this.$v.form.quantidade.required && errors.push('Número é obrigatório.')
    !this.$v.form.quantidade.numeric && errors.push('Apenas caracteres numéricos são válidos.')
    return errors
  },
}
